// Filter configurations for TpPortalMgt pages

/**
 * FPS Courses Filter Configuration
 */
export const fpsCourseFilters = [
  {
    name: "Course",
    type: "text",
    label: "Course",
    placeholder: "Search by course name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Subject",
    type: "text",
    label: "Subject",
    placeholder: "Search by subject...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Active",
    type: "boolean",
    label: "Active Status",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Credits",
    type: "text",
    label: "Credits",
    placeholder: "Search by credits...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * FPS (Faculty/Staff) Filter Configuration
 */
export const fpsFilters = [
  {
    name: "Last_Name",
    type: "text",
    label: "Last Name",
    placeholder: "Search by last name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "First_name",
    type: "text",
    label: "First Name",
    placeholder: "Search by first name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Full_Name",
    type: "text",
    label: "Full Name",
    placeholder: "Search by full name...",
    gridSize: { sm: 6, md: 4, lg: 6 },
  },
  {
    name: "Courses",
    type: "text",
    label: "Courses",
    placeholder: "Search by courses...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Active",
    type: "boolean",
    label: "Active Status",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Career_Days",
    type: "boolean",
    label: "Career Days",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Sinclair_Department",
    type: "select",
    label: "Department",
    options: [], // Will be populated from Department dropdown data
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Title",
    type: "text",
    label: "Title",
    placeholder: "Search by title...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Location",
    type: "text",
    label: "Location",
    placeholder: "Search by location...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Example configuration for other TpPortalMgt pages
 * These can be customized based on each page's specific needs
 */

export const studentsFilters = [
  {
    name: "FirstName",
    type: "text",
    label: "First Name",
    placeholder: "Search by first name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "LastName",
    type: "text",
    label: "Last Name",
    placeholder: "Search by last name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SCC_Email",
    type: "text",
    label: "SCC Email",
    placeholder: "Search by SCC email...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SCCID",
    type: "text",
    label: "Tartan ID",
    placeholder: "Search by Tartan ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "ProgramDeliveryID",
    type: "text",
    label: "Program Delivery ID",
    placeholder: "Search by program delivery ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "DeliveryDetailID",
    type: "text",
    label: "Delivery Detail ID",
    placeholder: "Search by delivery detail ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "HSGY",
    type: "text",
    label: "Graduation Year",
    placeholder: "Search by graduation year...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "CTE_requirement",
    type: "boolean",
    label: "CTE Requirement",
    valueNormalizer: (value) => {
      if (
        value === true ||
        value === "True" ||
        value === "true" ||
        value === "-1" ||
        value === -1 ||
        value === "Yes"
      )
        return "Yes";
      if (
        value === false ||
        value === "False" ||
        value === "false" ||
        value === "0" ||
        value === 0 ||
        value === "No"
      )
        return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "senior_packet",
    type: "select",
    label: "Senior Packet Status",
    customFilter: true, // Indicates this field needs special handling
    options: [
      { value: "TP Scholarship Packet", label: "TP Scholarship Packet" },
      {
        value: "TP Completer, No Scholarship",
        label: "TP Completer, No Scholarship",
      },
      { value: "TP Completer, No Tartan", label: "TP Completer, No Tartan" },
      { value: "Non-Completer", label: "Non-Completer" },
      { value: "Not Applicable", label: "Not Applicable" },
    ],
    gridSize: { sm: 6, md: 4, lg: 4 },
  },
  {
    name: "scholarship_eligible",
    type: "select",
    label: "Scholarship Status",
    customFilter: true, // Indicates this field needs special handling
    options: [
      { value: "Completer: Scholarship", label: "Completer: Scholarship" },
      {
        value: "Completer: Scholarship, SC ID Needed",
        label: "Completer: Scholarship, SC ID Needed",
      },
      {
        value: "Completer: No Scholarship",
        label: "Completer: No Scholarship",
      },
      {
        value: "Completer: No Scholarship, SC ID Needed",
        label: "Completer: No Scholarship, SC ID Needed",
      },
      { value: "CTE Requirement: No", label: "CTE Requirement: No" },
      { value: "Not Applicable", label: "Not Applicable" },
    ],
    gridSize: { sm: 6, md: 4, lg: 4 },
  },
  {
    name: "DOB",
    type: "daterange",
    label: "Date of Birth",
    gridSize: { sm: 6, md: 6, lg: 6 },
  },
  {
    name: "Application_Dt",
    type: "daterange",
    label: "Application Date",
    gridSize: { sm: 6, md: 6, lg: 6 },
  },
];

export const courseShellFilters = [
  {
    name: "shell_name",
    type: "text",
    label: "Shell Name",
    placeholder: "Search by shell name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "tp_final_approval",
    type: "boolean",
    label: "Final Approval",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "tp_final_authorization_name",
    type: "text",
    label: "Authorization Name",
    placeholder: "Search by authorization name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "tp_site_of_delivery",
    type: "select",
    label: "Site of Delivery",
    options: [], // Will be populated from Sites dropdown data
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "tp_partner",
    type: "select",
    label: "Partner",
    options: [], // Will be populated from Partner dropdown data
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "shell_school_year_start",
    type: "text",
    label: "School Year Start",
    placeholder: "Search by start year...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "shell_school_year_end",
    type: "text",
    label: "School Year End",
    placeholder: "Search by end year...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "shell_type",
    type: "text",
    label: "Shell Type",
    placeholder: "Search by shell type...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "tp_pathway_manager_name",
    type: "text",
    label: "Pathway Manager",
    placeholder: "Search by pathway manager...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Sites Filter Configuration
 */
export const sitesFilters = [
  {
    name: "SiteID",
    type: "text",
    label: "Site ID",
    placeholder: "Search by site ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SiteName",
    type: "text",
    label: "Site Name",
    placeholder: "Search by site name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SiteNameShort",
    type: "text",
    label: "Site Name Short",
    placeholder: "Search by short name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Coordinator_Site",
    type: "boolean",
    label: "Coordinator Site",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SiteAddress",
    type: "text",
    label: "Site Address",
    placeholder: "Search by address...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SiteCity",
    type: "text",
    label: "Site City",
    placeholder: "Search by city...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SiteState",
    type: "text",
    label: "Site State",
    placeholder: "Search by state...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SiteType",
    type: "text",
    label: "Site Type",
    placeholder: "Search by site type...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Partners Filter Configuration
 */
export const partnersFilters = [
  {
    name: "PartnerIRN",
    type: "text",
    label: "Partner IRN",
    placeholder: "Search by partner IRN...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Tech_Prep_Partner",
    type: "text",
    label: "Tech Prep Partner",
    placeholder: "Search by tech prep partner...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Partner_Full_Name",
    type: "text",
    label: "Full Name",
    placeholder: "Search by full name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Active_yn",
    type: "boolean",
    label: "Active Status",
    valueNormalizer: (value) => {
      const normalized = String(value || "")
        .trim()
        .toLowerCase();
      if (normalized === "y" || normalized === "yes") return "Yes";
      if (normalized === "n" || normalized === "no") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Shell Status Filter Configuration
 */
export const shellStatusFilters = [
  {
    name: "Status",
    type: "text",
    label: "Status",
    placeholder: "Search by status...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Record_Id",
    type: "text",
    label: "Record ID",
    placeholder: "Search by record ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Active",
    type: "boolean",
    label: "Active Status",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Dropdown_Option",
    type: "text",
    label: "Dropdown Option",
    placeholder: "Search by dropdown option...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Approval_Page_Option",
    type: "boolean",
    label: "Approval Page Option",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Residence Status Codes Filter Configuration
 */
export const residenceStatusCodesFilters = [
  {
    name: "Residence_Status",
    type: "text",
    label: "Residence Status",
    placeholder: "Search by residence status...",
    gridSize: { sm: 6, md: 4, lg: 6 },
  },
  {
    name: "Residence_Status_Code",
    type: "text",
    label: "Residence Status Code",
    placeholder: "Search by status code...",
    gridSize: { sm: 6, md: 4, lg: 6 },
  },
];

/**
 * SSN Status Code Filter Configuration
 */
export const ssnStatusCodeFilters = [
  {
    name: "SSN_Status",
    type: "text",
    label: "SSN Status",
    placeholder: "Search by SSN status...",
    gridSize: { sm: 6, md: 4, lg: 6 },
  },
  {
    name: "SSN_Status_Code",
    type: "text",
    label: "SSN Status Code",
    placeholder: "Search by status code...",
    gridSize: { sm: 6, md: 4, lg: 6 },
  },
];

/**
 * Program Delivery Filter Configuration
 */
export const programDeliveryFilters = [
  {
    name: "CCcode",
    type: "text",
    label: "CC Code",
    placeholder: "Search by CC code...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "PathwayID",
    type: "text",
    label: "Pathway ID",
    placeholder: "Search by pathway ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "ProgramDeliveryID",
    type: "text",
    label: "Program Delivery ID",
    placeholder: "Search by program delivery ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SiteOfDelivery",
    type: "select",
    label: "Site of Delivery",
    options: [], // Will be populated from Sites dropdown data
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SOD_NameForApp",
    type: "text",
    label: "SOD Name for App",
    placeholder: "Search by SOD name for app...",
    gridSize: { sm: 6, md: 4, lg: 6 },
  },
  {
    name: "BegDate",
    type: "daterange",
    label: "Begin Date",
    gridSize: { sm: 12, md: 6, lg: 3 },
  },
  {
    name: "EndDate",
    type: "daterange",
    label: "End Date",
    gridSize: { sm: 12, md: 6, lg: 3 },
  },
];

/**
 * Pathway Programs Filter Configuration
 */
export const pathwayProgramsFilters = [
  {
    name: "PathwayName",
    type: "text",
    label: "Pathway Name",
    placeholder: "Search by pathway name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "PathwayNameShort",
    type: "text",
    label: "Pathway Name Short",
    placeholder: "Search by short name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "PathwayAbbrev",
    type: "text",
    label: "Pathway Abbreviation",
    placeholder: "Search by abbreviation...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Career_Field_Cd",
    type: "text",
    label: "Career Field Code",
    placeholder: "Search by career field code...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "DivisionID",
    type: "select",
    label: "Division",
    options: [], // Will be populated from Division dropdown data
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SCCDirector",
    type: "text",
    label: "SCC Director",
    placeholder: "Search by SCC director...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SCCProgramMgr",
    type: "text",
    label: "SCC Program Manager",
    placeholder: "Search by program manager...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "SCCLiason",
    type: "text",
    label: "SCC Liaison",
    placeholder: "Search by SCC liaison...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "HEIProgramName",
    type: "select",
    label: "HEI Program",
    options: [], // Will be populated from HEI Program dropdown data
    gridSize: { sm: 6, md: 4, lg: 6 },
  },
];

/**
 * HEI Programs Filter Configuration
 */
export const heiProgramsFilters = [
  {
    name: "HEIProgramCode",
    type: "text",
    label: "HEI Program Code",
    placeholder: "Search by HEI program code...",
    gridSize: { sm: 6, md: 4, lg: 6 },
  },
  {
    name: "HEIProgramName",
    type: "text",
    label: "HEI Program Name",
    placeholder: "Search by HEI program name...",
    gridSize: { sm: 6, md: 4, lg: 6 },
  },
  {
    name: "Active",
    type: "boolean",
    label: "Active Status",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Elearn Shell Type Filter Configuration
 */
export const elearnShellTypeFilters = [
  {
    name: "name",
    type: "text",
    label: "Name",
    placeholder: "Search by shell type name...",
    gridSize: { sm: 6, md: 4, lg: 12 },
  },
];

/**
 * Divisions Filter Configuration
 */
export const divisionsFilters = [
  {
    name: "DivisionID",
    type: "text",
    label: "Division ID",
    placeholder: "Search by division ID...",
    gridSize: { sm: 6, md: 4, lg: 4 },
  },
  {
    name: "DivisionName",
    type: "text",
    label: "Division Name",
    placeholder: "Search by division name...",
    gridSize: { sm: 6, md: 4, lg: 4 },
  },
  {
    name: "Active",
    type: "boolean",
    label: "Active Status",
    options: [
      { value: "Active", label: "Active" },
      { value: "Inactive", label: "Inactive" },
    ],
    valueNormalizer: (value) => {
      if (value === true) return "Active";
      if (value === false) return "Inactive";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 4 },
  },
];

/**
 * Delivery Details Filter Configuration
 */
export const deliveryDetailsFilters = [
  {
    name: "ProgramDeliveryID",
    type: "text",
    label: "Program Delivery ID",
    placeholder: "Search by program delivery ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "DeliveryDetailsID",
    type: "text",
    label: "Delivery Details ID",
    placeholder: "Search by delivery details ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "HEIProgramCode",
    type: "text",
    label: "HEI Program Code",
    placeholder: "Search by HEI program code...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "InstructorID",
    type: "select",
    label: "Instructor",
    options: [], // Populated at runtime with active/inactive instructors
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "CTE_Program_Cd",
    type: "text",
    label: "CTE Program Code",
    placeholder: "Search by CTE program code...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "MVTPCstrand",
    type: "text",
    label: "MVTPC Strand",
    placeholder: "Search by MVTPC strand...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Active",
    type: "boolean",
    label: "Active Status",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "StrandNonactive",
    type: "boolean",
    label: "Strand Nonactive",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "InstructorNonactiveInStrand",
    type: "boolean",
    label: "Instructor Nonactive In Strand",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 6 },
  },
  {
    name: "SRGradClass",
    type: "boolean",
    label: "SR Grad Class",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "JRclass",
    type: "boolean",
    label: "JR Class",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * CTAG Retrieval Form Filter Configuration
 */
export const ctagRetrievalFormFilters = [
  {
    name: "Data_Status_Note",
    type: "text",
    label: "Data Status Note",
    placeholder: "Search by data status note...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Last_Name",
    type: "text",
    label: "Last Name",
    placeholder: "Search by last name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "First_Name",
    type: "text",
    label: "First Name",
    placeholder: "Search by first name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Tartan_Id",
    type: "text",
    label: "Tartan ID",
    placeholder: "Search by Tartan ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Sinclair_Email",
    type: "text",
    label: "Sinclair Email",
    placeholder: "Search by Sinclair email...",
    gridSize: { sm: 6, md: 4, lg: 4 },
  },
  {
    name: "HSGY",
    type: "text",
    label: "HSGY",
    placeholder: "Search by HSGY...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "DOB",
    type: "text",
    label: "Date of Birth",
    placeholder: "Search by date of birth...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "created_at",
    type: "daterange",
    label: "Create Date",
    gridSize: { sm: 12, md: 6, lg: 4 },
  },
];

/**
 * CTAG/ITAG Catalog Filter Configuration
 */
export const ctagFilters = [
  {
    name: "CTAN",
    type: "text",
    label: "CTAN",
    placeholder: "Search by CTAN...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "CTAN_Name",
    type: "text",
    label: "CTAN Name",
    placeholder: "Search by CTAN name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "EMIS_Code",
    type: "text",
    label: "EMIS Code",
    placeholder: "Search by EMIS code...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "ODE_career_field",
    type: "text",
    label: "ODE Career Field",
    placeholder: "Search by ODE career field...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Articulation_Number",
    type: "text",
    label: "Articulation Number",
    placeholder: "Search by articulation number...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Sinclair_Course",
    type: "text",
    label: "Sinclair Course",
    placeholder: "Search by Sinclair course...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Sinclair_Subject_Short",
    type: "text",
    label: "Sinclair Subject Short",
    placeholder: "Search by subject short...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Sinclair_Subject_Long",
    type: "text",
    label: "Sinclair Subject Long",
    placeholder: "Search by subject long...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Credits",
    type: "numberrange",
    label: "Credits",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Course Catalog Filter Configuration
 */
export const courseCatalogFilters = [
  {
    name: "Course",
    type: "text",
    label: "Course",
    placeholder: "Search by course...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Subject",
    type: "text",
    label: "Subject",
    placeholder: "Search by subject...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Lab_Type_Course",
    type: "boolean",
    label: "Lab Type Course",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Credit_Type",
    type: "text",
    label: "Credit Type",
    placeholder: "Search by credit type...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Ode_Course",
    type: "text",
    label: "ODE Course",
    placeholder: "Search by ODE course...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "TP_Pathway",
    type: "text",
    label: "TP Pathway",
    placeholder: "Search by TP pathway...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Credits",
    type: "numberrange",
    label: "Credits",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Course Shell Status Filter Configuration
 */
export const courseShellStatusFilters = [
  {
    name: "Name",
    type: "text",
    label: "Name",
    placeholder: "Search by name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Credit Types Filter Configuration
 */
export const creditTypesFilters = [
  {
    name: "Credit_Type_abv",
    type: "text",
    label: "Credit Type Abbreviation",
    placeholder: "Search by abbreviation...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Credit_Type_Name",
    type: "text",
    label: "Credit Type Name",
    placeholder: "Search by name...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Note",
    type: "text",
    label: "Note",
    placeholder: "Search by note...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Credit Capture Filter Configuration
 */
export const creditCaptureFilters = [
  {
    name: "CTAN",
    type: "text",
    label: "CTAN",
    placeholder: "Search by CTAN...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Tartan_ID",
    type: "text",
    label: "Tartan ID",
    placeholder: "Search by Tartan ID...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Course",
    type: "text",
    label: "Course",
    placeholder: "Search by course...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "CourseAndSubject",
    type: "text",
    label: "Course & Subject",
    placeholder: "Search by course and subject...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Grade",
    type: "text",
    label: "Grade",
    placeholder: "Search by grade...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Course_School_Year",
    type: "text",
    label: "Course School Year",
    placeholder: "Search by school year...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "CreditType",
    type: "text",
    label: "Credit Type",
    placeholder: "Search by credit type...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Subject",
    type: "text",
    label: "Subject",
    placeholder: "Search by subject...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "TP_Section",
    type: "text",
    label: "TP Section",
    placeholder: "Search by TP section...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "PLTW_credit",
    type: "boolean",
    label: "PLTW Credit",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "PermissionToPostCredit",
    type: "boolean",
    label: "Permission to Post Credit",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Posted",
    type: "boolean",
    label: "Posted",
    valueNormalizer: (value) => {
      if (value === -1 || value === "-1" || value === "Yes") return "Yes";
      if (value === 0 || value === "0" || value === "No") return "No";
      return "";
    },
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "School_Year_Posted",
    type: "text",
    label: "School Year Posted",
    placeholder: "Search by posted year...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Note",
    type: "text",
    label: "Note",
    placeholder: "Search by note...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "Credits",
    type: "numberrange",
    label: "Credits",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Schools Filter Configuration
 */
export const schoolsFilters = [
  {
    name: "search",
    type: "text",
    label: "Search All",
    placeholder: "Search schools by any field...",
    gridSize: { sm: 12, md: 6, lg: 4 },
  },
  {
    name: "district",
    type: "select",
    label: "District",
    options: [], // Will be populated from unique districts in data
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "main_contact",
    type: "text",
    label: "Main Contact",
    placeholder: "Search by main contact...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "main_email",
    type: "text",
    label: "Main Email",
    placeholder: "Search by email...",
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "operations",
    type: "select",
    label: "Operations",
    options: [], // Will be populated from users with ccpAdminFlag
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
  {
    name: "pathway",
    type: "select",
    label: "Pathway",
    options: [], // Will be populated from users with ccpAdminFlag
    gridSize: { sm: 6, md: 4, lg: 3 },
  },
];

/**
 * Export all configurations
 */
export const filterConfigurations = {
  fpsCourses: fpsCourseFilters,
  fps: fpsFilters,
  students: studentsFilters,
  courseShell: courseShellFilters,
  sites: sitesFilters,
  partners: partnersFilters,
  shellStatus: shellStatusFilters,
  residenceStatusCodes: residenceStatusCodesFilters,
  ssnStatusCode: ssnStatusCodeFilters,
  programDelivery: programDeliveryFilters,
  pathwayPrograms: pathwayProgramsFilters,
  heiPrograms: heiProgramsFilters,
  elearnShellType: elearnShellTypeFilters,
  divisions: divisionsFilters,
  deliveryDetails: deliveryDetailsFilters,
  ctagRetrievalForm: ctagRetrievalFormFilters,
  ctag: ctagFilters,
  courseCatalog: courseCatalogFilters,

  courseShellStatus: courseShellStatusFilters,
  creditTypes: creditTypesFilters,
  creditCapture: creditCaptureFilters,
  schools: schoolsFilters,
};
